import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FinalFeedbackPage } from './final-feedback.page';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { AutoSaveModule } from '../shared/components/autosave/autosave.module';
import { StepDescriptionModule } from '../shared/components/step-description/step-description.module';
import { UtilService } from '../shared/services/util.service';
import { FinalFeedbackService } from './final-feedback.service';
import {QuestionTypesModule} from "../shared/components/question-types/question-types.module";
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';

const routes: Routes = [{
  path: '',
  component: FinalFeedbackPage
}];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        PipesModule,
        FormsModule,
        ReactiveFormsModule,
        StepDescriptionModule,
        AutoSaveModule,
        QuestionTypesModule,
        MatTooltipModule
    ],
  declarations: [
    FinalFeedbackPage
  ],
  providers: [
    FinalFeedbackService,
    UtilService
  ]
})
export class FinalFeedbackModule { }
